export const independentContractorRepresentativesAndWarranties = () => {
  return [
    { text: '     5. INDEPENDENT CONTRACTOR REPRESENTATIONS AND WARRANTIES.', bold: true, style: 'p', },

    { text: `     For purposes of this TICA, and as further inducement for Company to contract with Independent Contractor hereunder, Independent Contractor in the scope and course of its own services, represents and warrants that:`, style: 'p' },

    {
      text: [
        { text: `     5.1.`, bold: true },
        { text: ` Independent Contractor and its employees, contractors, and agents are each duly qualified to perform the Services and are properly licensed to operate all Equipment under Independent Contractor’s care, custody, and control. Independent Contractor hereby represents and warrants that Independent Contractor will maintain any and all required licenses and permits required to provide the TICA Services throughout the Term of this TICA; and,` },
      ],
      style: 'p',
    },

    {
      text: [
        { text: `     5.2.`, bold: true },
        { text: ` Independent Contractor will take all ordinary and necessary steps to preserve, safeguard and protect from damage, theft or other loss, all property which comes into Independent Contractor’s possession while performing any activities under this TICA.` }
      ],
      style: 'p',
    },
  ]
}